import { PlanService } from './plan'

class GoodsService {
  static isPlan(item: GoodsType): item is Dto.Plan {
    return !!item && typeof item === 'object' && 'plan_type' in item
  }

  static isPack(item: GoodsType): item is Dto.Pack {
    return !!item && typeof item === 'object' && 'pack_type' in item
  }

  static isProduct(item: GoodsType): item is Dto.Product {
    return !!item && typeof item === 'object' && 'in_stock' in item
  }

  static getType(item: GoodsType) {
    return this.isPlan(item)
      ? 'plan'
      : this.isPack(item)
      ? 'pack'
      : this.isProduct(item)
      ? 'product'
      : undefined
  }

  static getPrice(item: GoodsType) {
    if (this.isPlan(item)) {
      return PlanService.getPrice(item)
    }

    return item.price
  }

  static getRoughPrice(item: GoodsType) {
    const price = this.getPrice(item)

    if (typeof price === 'number') {
      return price
    }

    return price.number
  }
}

type GoodsType = Dto.Plan | Dto.Pack | Dto.Product

export { GoodsService }
export type { GoodsType }
